import { render, staticRenderFns } from "./CrosUpdataFile.vue?vue&type=template&id=3318fbce"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3318fbce')) {
      api.createRecord('3318fbce', component.options)
    } else {
      api.reload('3318fbce', component.options)
    }
    module.hot.accept("./CrosUpdataFile.vue?vue&type=template&id=3318fbce", function () {
      api.rerender('3318fbce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/CrosUpdataFile.vue"
export default component.exports